import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App';

// Portadas rotas (p. ej. las que estaban alojadas en AnimeFLV): placeholder en
// vez del ícono de imagen rota. Captura en document porque 'error' no burbujea.
const NO_COVER = '/no-cover.svg';
document.addEventListener('error', (e) => {
  const img = e.target;
  if (img.tagName !== 'IMG' || img.src.endsWith(NO_COVER)) return;
  img.src = NO_COVER;
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
